import React from 'react';
import clsx from 'clsx'
import { Box, Card, Skeleton, Typography } from '@mui/material'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'

// azul da marca (logo), mesmo padrão da tela de login
export const brandBlue = '#015192'
export const brandBlueDark = '#013a69'

const useStyles = makeStyles(() => ({
  root: {
    // a altura é igualada pelo item da grade (display: flex) e não por height: 100%,
    // que não é resolvido de forma confiável dentro do Grid com quebra de linha
    flex: 1,
    width: '100%',
    minHeight: 150,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '20px 20px 16px',
    borderRadius: '14px!important',
    border: '1px solid #e8ecf1',
    boxShadow: '0 2px 10px rgba(15, 23, 42, 0.05)!important',
    transition: 'transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease'
  },
  clickable: {
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-2px)',
      borderColor: 'rgba(1, 81, 146, 0.35)',
      boxShadow: '0 10px 24px rgba(1, 81, 146, 0.12)!important'
    },
    '&:hover $more': {
      color: brandBlue
    }
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12
  },
  label: {
    fontSize: '14px!important',
    fontWeight: '500!important',
    color: '#6b7280',
    lineHeight: '1.4!important'
  },
  iconBox: {
    flexShrink: 0,
    width: 44,
    height: 44,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(1, 81, 146, 0.10)',
    color: brandBlue,
    '& .MuiSvgIcon-root': {
      fontSize: 24
    }
  },
  value: {
    marginTop: '12px!important',
    fontSize: '28px!important',
    fontWeight: '700!important',
    lineHeight: '1.2!important',
    color: '#111827',
    wordBreak: 'break-word'
  },
  more: {
    marginTop: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    fontSize: 13,
    fontWeight: 600,
    color: '#9ca3af',
    transition: 'color 0.15s ease',
    '& .MuiSvgIcon-root': {
      fontSize: 16
    }
  }
}));

// card de indicador do dashboard: rótulo, valor e ícone
const StatCard = (props) => {
  const { className, label, value, icon, onClick, ...rest } = props
  const classes = useStyles();

  const isLoading = useSelector((state) => state.dashboard?.isLoading)

  return (
    <Card
      {...rest}
      onClick={onClick}
      className={clsx(classes.root, onClick && classes.clickable, className)}
    >
      <Box>
        <div className={classes.header}>
          <Typography className={classes.label}>
            {label}
          </Typography>
          <div className={classes.iconBox}>
            {icon}
          </div>
        </div>
        <Typography className={classes.value}>
          {isLoading ? <Skeleton animation="wave" width="60%" /> : value}
        </Typography>
      </Box>
      {onClick &&
        <div className={classes.more}>
          Ver detalhes <ArrowForwardRoundedIcon />
        </div>
      }
    </Card>
  );
}

StatCard.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
  icon: PropTypes.node,
  onClick: PropTypes.func
}

export default StatCard
